module.exports = __webpack_public_path__ + "static/img_4904-ba59be5f0f25f9b0707c3d50e07ee66e.webp";